module.exports = __webpack_public_path__ + "static/flags/IV-ac62408f9a8e0c750e08250c3f8c99b6.gif";